import type { FAQItem, ResourcePageSeo } from "../resource-seo";

export const faqs: FAQItem[] = [
  {
    question: "What are MindMyJob Hiring Trends?",
    answer:
      "Monthly data on what employers are asking for: the most requested skills for each role, where roles are open by city and industry, and new job titles that are starting to appear.",
  },
  {
    question: "Where does the hiring data come from?",
    answer:
      "From job postings collected across the boards MindMyJob searches, such as LinkedIn, Naukri and Indeed. Duplicate postings are removed before trends are calculated.",
  },
  {
    question: "Which skills are most in demand right now?",
    answer:
      "It depends on the role. Pick a job title to see its top skills ranked by how often they appear in postings, along with which ones are growing and which are cooling.",
  },
  {
    question: "How can I use hiring trends in my job search?",
    answer:
      "Use them to decide which skills to learn next, which keywords to add to your resume, and which cities or industries to focus your applications on.",
  },
  {
    question: "What counts as an emerging role?",
    answer:
      "A job title that was rare a year ago and now appears in postings every week, such as AI evaluation engineer or design engineer. Each one shows the skills it asks for and typical pay.",
  },
  {
    question: "Can I see remote, hybrid and on-site demand?",
    answer:
      "Yes. Role demand shows the split between on-site, hybrid and remote roles for each city.",
  },
  {
    question: "How often is the data updated?",
    answer:
      "Trends are refreshed every month, and open-role counts are refreshed more often.",
  },
];

export const seo: ResourcePageSeo = {
  slug: "hiring-trends",
  name: "Hiring Trends",
  title: "Hiring Trends: In-Demand Skills and Roles | MindMyJob",
  description:
    "See the skills employers ask for most, where your role is hiring by city and work type, and new job titles worth preparing for, from real postings.",
  keywords: [
    "hiring trends",
    "in demand skills",
    "most in demand tech skills",
    "job market trends india",
    "skills employers want",
    "emerging job roles",
    "remote job trends",
    "jobs in demand by city",
    "future of work skills",
    "what skills to learn for jobs",
  ],
  ogImage: "/assets/images/resources/hiring-trends/hero-skills.png",
  ogImageAlt:
    "MindMyJob Hiring Trends showing top skills for Software Engineer postings with growth rates",
  featureList: [
    "Top skills by role",
    "Rising and cooling skills",
    "Role demand by city and industry",
    "Remote, hybrid and on-site split",
    "Emerging roles with skills and pay",
  ],
  faqs,
};
